import numberType from './number';

export default numberType;
